import axiosInstance from 'helpers/axiosInstance';

export interface ConsentGiver {
  firstName: string;
  lastName: string;
  email: string;
}

export const addConsentGiversToMember = (
  memberId: string,
  consentGivers: ConsentGiver[],
) => {
  return Promise.all(
    consentGivers.map(cg =>
      axiosInstance.post(`/patients/patients/${memberId}/consent_givers`, {
        consentGiver: cg,
      }),
    ),
  );
};
